import { categories } from '@/configs/translates.config'
export default {
	'add-new-category': `Add new ${categories.en.singular}`,
	category: categories.en.singular,
	'the-category': `the ${categories.en.singular}?`,
	attribute: 'Attribute',
	attributes: 'Attributes',
	'$-options': '{name} options',
	'options-count': 'Options count',
	option: 'option'
}